import { render, staticRenderFns } from "./notification-container.vue?vue&type=template&id=02a23d9e"
import script from "./notification-container.vue?vue&type=script&lang=js"
export * from "./notification-container.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./notification-container.vue?vue&type=custom&index=0&blockType=graphql"
if (typeof block0 === 'function') block0(component)

export default component.exports